(() => {
  const root = document.documentElement;
  root.classList.add('newinhere-ready');

  const reveal = () => {
    const nodes = document.querySelectorAll('.newinhere-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px 8% 0px', threshold: 0.03 }
    );

    nodes.forEach((node) => observer.observe(node));
  };

  const refresh = () => window.requestAnimationFrame(reveal);
  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', refresh);
})();
